import { render, staticRenderFns } from "./ModalDeleteTimeline.vue?vue&type=template&id=a25fe65c&"
import script from "./ModalDeleteTimeline.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports